import Grid from '@mui/material/Grid';
import { TextField } from '@mui/material';
import React from 'react';
import { NumberOfUnitsState } from '../../../types/DrugDosages.type';
import { DrugSelect } from '../SharedComponents/DrugSelect';
import { ResultTextNumberOfUnits } from './ResultTextNumberOfUnits';
import { CalculateButton } from '../SharedComponents/CalculateButton';
import { CalculatorRowTitleGridItem } from '../SharedComponents/CalculatorRowTitleGridItem';
import { numberInputProps } from '../../../config/constant.params';

export const NumberOfUnitsRow = ({
  state,
  handleInputChange,
  handleCalculateClick,
  mobile,
}: {
  state: NumberOfUnitsState;
  handleInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleCalculateClick: () => void;
  mobile: boolean;
}) => {
  return (
    <Grid container spacing={2}>
      <CalculatorRowTitleGridItem>
        CALCULATE NUMBER OF UNITS, E.G. TABLETS
      </CalculatorRowTitleGridItem>
      <Grid item xs={8} sm={2}>
        <TextField
          name="strength"
          label="Strength"
          fullWidth
          variant="outlined"
          onChange={handleInputChange}
          type="number"
          value={state.strength.value}
          error={state.strength.error}
          inputProps={numberInputProps}
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={8} sm={2}>
        <DrugSelect
          value={state.mgPerUnit.value}
          error={state.mgPerUnit.error}
          handleChange={handleInputChange}
        />
      </Grid>
      <Grid item xs={8} sm={2}>
        <TextField
          name="dose"
          label="Dose (mg/kg)"
          fullWidth
          variant="outlined"
          type="number"
          onChange={handleInputChange}
          value={state.dose.value}
          error={state.dose.error}
          inputProps={numberInputProps}
          autoComplete="off"
        />
      </Grid>
      <Grid item xs={8} sm={2}>
        <CalculateButton
          handleCalculateClick={handleCalculateClick}
          mobile={mobile}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <TextField
          name="dose"
          label="Result"
          fullWidth
          variant="outlined"
          type="number"
          disabled
          value={state.result}
        />
      </Grid>
      <Grid item xs={6} sm={2}>
        <ResultTextNumberOfUnits mgPerUnit={state.mgPerUnit.value} />
      </Grid>
    </Grid>
  );
};
